import { useState } from "react";
import { EllipsisVIcon } from "../../assets/icons";
import { IconButton } from "../IconButton";
import "./ListBox.scss";

/**
 * ListBox component
 * @param {{
 *   options: {text: string, onClick?: () => void}[],
 *   className?: string,
 *   icon?:import("react").ReactNode
 * }} props
 * @returns {JSX.Element} ListBox
 */
function ListBox({ className, options, icon }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={`list-box ${className}`}>
      <div className="toggle-btn">
        <IconButton icon={icon ? icon : <EllipsisVIcon />} onClick={() => setExpanded((prev) => !prev)} />
      </div>

      <div className={`list-content ${expanded ? "expand" : ""}`}>
        {options.map((o, k) => (
          <button className="list-option" key={k} onClick={o.onClick}>
            <span>{o.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default ListBox;
